import { OnInit, ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UrlService } from "src/app/miscellaneous/url.service";
import { MenuService } from "src/app/services/menu-service.service";
import { EMPTY, filter, mapTo, of, race, startWith, Subject, switchMap, take, takeUntil, tap, timer } from "rxjs";
import { DataService } from "src/app/services/data.service";
import { ObbligoProvider } from "src/app/services/obbligo.provider";

@Component({
  selector: "app-dynamic-content",
  templateUrl: "./dynamic-content.component.html",
  styleUrls: ["./dynamic-content.component.scss"],
  providers: [UrlService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicContentComponent implements OnInit {
  @Input() template!: string;

  @Input() props!: any;

  static compName = "DynamicContent";

  /**
   * Subject per l'OnDestroy del componente.
   */
  private destroy$ = new Subject<void>();

  constructor(
    private _urlService: UrlService,
    private _obbligoProvider: ObbligoProvider,
    private _dataService: DataService,
    private _menuService: MenuService
  ) { }

  /**
   * @inheritdoc
   */
  ngOnInit(): void {
    this.template = this.props.templateId;
    this.fetchGetObbligoDetails();
  }


  fetchGetObbligoDetails(): void {
    if (!this.props.endpoint) return;

    // Prova a ottenere menuItem$ entro 2000ms, altrimenti passa null
    race(
      this._menuService.menuItem$.pipe(
        filter((item) => !!item),
        take(1)
      ),
      timer(2000).pipe(mapTo(null)) // se dopo 500ms non arriva nulla, vai avanti con null
    )
      .pipe(
        switchMap((item) => {
          const id = this.props.concatKey && item ? item.key : this._urlService.getUrlId();
          const endpoint = id ? `${this.props.endpoint}/${id}` : this.props.endpoint;

          const currentDetails = this._obbligoProvider.getObbligoDetails();
          if (id && currentDetails && currentDetails.id === id) {
            return of(currentDetails).pipe(
              tap((res) => this._obbligoProvider.setObbligoDetails(res))
            );
          }

          return this._dataService.getData(endpoint).pipe(
            tap((res) => this._obbligoProvider.setObbligoDetails(res))
          );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }


  /**
   * @inheritdoc
   */
  ngOnDestroy(): void {
    this._obbligoProvider.clearObbligoDetails();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
